import React, { PureComponent } from 'react'
import { string, bool, func, any, arrayOf, shape } from 'prop-types'
import { connect } from 'react-redux'
import PhaseActions from 'store/redux/phase'
import GlobalActions from 'store/redux/global'
import AuthActions from 'store/redux/auth'
import { SectionActions, Button, InterTitle } from 'components'
import { translate } from 'react-i18next'
import PHASE from 'utils/constants/phases'
import GameTemplate from '../templates/GameTemplate'
import './Phases.css'

@connect(
    state => ({
        phase: state.phaseInfo.phase,
        isEndingSelection: state.global.loading,
        isFinalSeason: state.phaseInfo.season === state.phaseInfo.totalSeasons,
        isFinalRaceForThisSeason:
            state.phaseInfo.race === state.phaseInfo.totalRaces
    }),
    {
        endPhase: PhaseActions.endPhase,
        modalInfo: GlobalActions.info,
        modalRequest: GlobalActions.request,
        signout: AuthActions.signout
    }
)
@translate()
export class Phase extends PureComponent {
    static propTypes = {
        phaseRef: func,
        className: string.isRequired,
        phase: string.isRequired,
        showEndPhaseBtn: bool,
        children: any.isRequired,
        interTitles: arrayOf(
            shape({
                image: string,
                title: string,
                text: string
            })
        )
    }
    static defaultProps = {
        showEndPhaseBtn: true,
        interTitles: []
    }

    componentWillMount() {
        const { phaseRef, interTitles } = this.props
        phaseRef && phaseRef(this)
        this.interTitlesReversed = (interTitles || [])
            .map((data, index) => ({
                ...data,
                duration: (index + 1) * 2000
            }))
            .reverse()
    }
    showModalErrorInfo = (error, callback, extraData) => {
        const { modalInfo, t } = this.props
        if (error === 'MAX_UNITS_EXCEED') {
            modalInfo({
                title: t('modals.maxUnitsExceed.title'),
                text: t('modals.maxUnitsExceed.text'),
                callback
            })
        } else if (error === 'CREDITS_EXCEED') {
            modalInfo({
                title: t('modals.notEnoughCredits.title'),
                text: t('modals.notEnoughCredits.text'),
                callback
            })
        } else if (error === 'DRIVING_AGGRESSIVE_EXCEEDED') {
            modalInfo({
                title: t('modals.drivingAggressiveExceeded.title'),
                text: t('modals.drivingAggressiveExceeded.text', {
                    threshold: extraData.threshold
                }),
                callback
            })
        } else if (error === 'CREDITS_EXCEED_PITSTOP') {
            modalInfo({
                title: t('modals.notEnoughCreditsPitstops.title'),
                text: t('modals.notEnoughCreditsPitstops.text'),
                callback
            })
        } else if (error === 'ITEM_JUST_INFORMATIVE') {
            modalInfo({
                title: t('modals.itemJustInformative.title'),
                text: t('modals.itemJustInformative.text'),
                callback
            })
        }
    }

    handleEndSelection = () => {
        const {
            phase,
            modalRequest,
            endPhase,
            isFinalSeason,
            isFinalRaceForThisSeason,
            signout,
            t
        } = this.props
        if (
            phase === PHASE.POST_SEASON &&
            isFinalSeason &&
            isFinalRaceForThisSeason
        ) {
            const endPhaseAndSignout = () => {
                endPhase()
                setTimeout(signout, 500)
            }
            modalRequest({
                title: t('modals.endGameConfirmation.title'),
                text: t('modals.endGameConfirmation.text'),
                actionBtns: [
                    {
                        text: t('modals.endGameConfirmation.doneBtn'),
                        action: endPhaseAndSignout
                    },
                    { text: t('modals.endGameConfirmation.cancelBtn') }
                ]
            })
        } else if (phase === PHASE.RACE || phase === PHASE.POST_SEASON) {
            endPhase()
        } else {
            modalRequest({
                title: t('modals.selectionConfirmation.title'),
                text: t('modals.selectionConfirmation.text'),
                actionBtns: [
                    {
                        text: t('modals.selectionConfirmation.doneBtn'),
                        action: endPhase
                    },
                    { text: t('modals.selectionConfirmation.cancelBtn') }
                ]
            })
        }
    }

    renderInterTitle = ({ image, title, text, duration }) => (
        <InterTitle
            key={duration}
            image={image}
            title={title}
            text={text}
            duration={duration}
        />
    )
    render() {
        const {
            phase,
            className,
            showEndPhaseBtn,
            isEndingSelection,
            isFinalSeason,
            isFinalRaceForThisSeason,
            children,
            t
        } = this.props
        let endBtnText = t(`game.${phase}.btnEnd`)
        if (phase === PHASE.RACE && isFinalRaceForThisSeason) { endBtnText = t('game.RACE.btnEndSeason') } else if (
            phase === PHASE.POST_SEASON &&
            isFinalSeason &&
            isFinalRaceForThisSeason
        ) { endBtnText = t('game.POST_SEASON.btnEndGame') }

        return (
            <GameTemplate className={className}>
                {children}
                <SectionActions show={showEndPhaseBtn}>
                    <Button
                        color="primary"
                        onClick={this.handleEndSelection}
                        loading={isEndingSelection}
                    >
                        {endBtnText}
                    </Button>
                </SectionActions>

                {this.interTitlesReversed.map(this.renderInterTitle)}
            </GameTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Phases/Phase.js